const verticalMenu = (function () {
    const _settings = {
        menuElements: document.querySelectorAll(".js-vertical-menu-container > ul > li ul"), // All menu holding UL elements
        menuContainer: document.querySelector(".js-vertical-menu-container"),
        menuIcon: document.querySelector(".js-vertical-menu-icon"),
        mainPageContentContainer: document.querySelector(".l-siteContent, .o-sitePage__main"),
    };

    /**
     * Removes element highlighting in vertical navigation drawer. Element is
     * highlighted when user selects a parent menu item and displays its
     * child elements.
     */
    function _removeMenuSelectedElementHighlights() {
        /**
         * When turning off menu, remove selected items and open menus
         * from display so they are not open if user reselects menu
         */
        _settings.menuElements.forEach((element) => {
            // turn off display for all UL items and remove selected highlight except for menu element associated with the click
            element.style.cssText = "display: none";
            element.previousElementSibling.classList.remove("m-navMenu__selected");
        });
    }

    /**
     * Displays vertical navigation drawer
     */
    function showVerticalMenu() {
        if (
            _settings.menuContainer.style.getPropertyValue("display") === "" ||
            _settings.menuContainer.style.getPropertyValue("display") === "none"
        ) {
            _settings.menuContainer.style.cssText = "display: block";
            _settings.menuIcon.innerHTML = "arrow_back";

            if (_settings.mainPageContentContainer) {
                _settings.mainPageContentContainer.style.cssText = "overflow-y: hidden";
            }
        } else {
            _settings.menuContainer.style.cssText = "display: none";
            _settings.menuIcon.innerHTML = "menu";
            if (_settings.mainPageContentContainer) {
                _settings.mainPageContentContainer.style.cssText = "overflow-y: auto";
            }
        }
    }

    /**
     * Handle display of vertical navigation drawer
     *
     * @param {object} menuElement menu element selected
     */
    function showSubMenu(menuElement) {
        /**
         * Check if selected element is part of a sub-menu. If not, close
         * all existing open menus.
         */

        if (menuElement.closest(".m-siteNav__verticalContainer") === null) {
            return;
        }
        const target = menuElement.nextElementSibling; //  UL element triggered to open/close by click

        const closestElement = menuElement.closest(".sub-menu"); // LI element identified as an item with a sub-menu

        // When a parent menu item is selected, remove all other selected items and open menus
        if (closestElement === null) {
            _removeMenuSelectedElementHighlights();
        } else {
            // When a child menu item is selected, remove all other selected submenu items and open menus

            // Get all submenus within this parent menu
            const otherSubMenus = closestElement.parentElement.querySelectorAll(".sub-menu");

            // For each submenu, remove selected highlight and close menu
            otherSubMenus.forEach((element) => {
                element.querySelector("ul").style.cssText = "display: none"; // turn off display of submenu
                element.querySelector("ul a").classList.remove("m-navMenu__selected"); // remove selected class from submenu link
            });
        }

        /**
         * Open/close menu associated with clicked element
         */
        if (target.style.getPropertyValue("display") === "" || target.style.getPropertyValue("display") === "none") {
            target.style.cssText = "display: block";
            menuElement.classList.add("m-navMenu__selected");
        } else {
            target.style.cssText = "display: none";
            menuElement.className = "m-navMenu__selected";
            menuElement.classList.remove("m-navMenu__selected");
            menuElement.blur();
        }
    }

    return {
        showSubMenu: showSubMenu,
        showVerticalMenu: showVerticalMenu,
    };
})();

export { verticalMenu };
